// extracted by mini-css-extract-plugin
export default {"wrapper":"topTeachers_wrapper__xZ6de","title":"topTeachers_title__Paabz"};